import { SectionHead } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/Reveal";

const steps = [
  {
    t: "Position the bracket on the post",
    p: "Square or round tubing, either one. Decide flush or bypass first, then set your height and check it level before anything goes in.",
  },
  {
    t: "Drill pilot holes if necessary",
    p: "Heavier wall post, or you just want the screw to start dead on the mark. Most of the time the self-drilling point handles it.",
  },
  {
    t: "Screw the bracket to the post",
    p: 'Use the included #10 × 3/4" pan head self-drilling screws through the center hole cluster. Minimum of two per post.',
    tag: "Minimum 2 fasteners — post (201)",
  },
  {
    t: "Repeat on the second post",
    p: "Same height, same mount style. A string line or a level laid across both brackets keeps the run true.",
  },
  {
    t: "Set the railing",
    p: "Square tubing, rectangular tubing, or cee purlin slips over the bracket's upturned end tabs.",
  },
  {
    t: "Screw the railing to the bracket",
    p: "Same screws, through the rail into the end tabs. Minimum of four per bracket.",
    tag: "Minimum 4 fasteners — rail (202)",
  },
  {
    t: "Hang your fencing",
    p: "With the rails in, attach panel, mesh, or sheet to the runners the same way you would on any welded frame.",
  },
];

export const InstallSequence = () => (
  <section className="section" id="install" data-testid="install-section">
    <div className="wrap">
      <SectionHead num="02" eyebrow="Install sequence — per post" title="Seven steps, start to finished run." />
      <ol className="steps">
        {steps.map((s, i) => (
          <Reveal key={s.t} delay={(i % 2) * 0.1}>
            <li className="step" data-testid={`install-step-${i + 1}`}>
              <div className="step-n" aria-hidden="true">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <h3>{s.t}</h3>
                <p>{s.p}</p>
                {s.tag && <span className="step-tag">{s.tag}</span>}
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
